import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=266ef413&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266ef413"]])

export default __exports__